import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface BangTinhPhanBoCCDCTTResponse<T = any> {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
}

export const fetchAllBangTinhPhanBoCCDCTT = async (
  entitySlug: string,
  body: Record<string, any> = {},
  pageSize = 200
): Promise<any[]> => {
  let page = 1;
  let all: any[] = [];

  while (true) {
    const response = await api.post<BangTinhPhanBoCCDCTTResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.BANG_TINH_PHAN_BO_CCDC_THEO_THANG}/`,
      body,
      {
        params: {
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    all = all.concat(pageResults);

    if (!response.data.next) {
      break;
    }

    page += 1;
  }

  return all;
};
